$(document).ready(function() {
	$('.cour-ctrl-js').on('click', function() {
		const $btn = $(this).closest(".cour-grid").find(".cour-ctrl");
		const $accordion = $btn.closest('.accord').find('.cour-desc-wrap');

		const isOpen = $accordion.hasClass('open');
		
		// Animation ouverture/fermeture
		$accordion.toggleClass('open', !isOpen);

		// Changement de l'icône
		if (!isOpen) {
			$btn.html(`
				<svg width="16" height="2" viewBox="0 0 16 2" fill="none" xmlns="http://www.w3.org/2000/svg">
					<rect width="16" height="2" rx="1" fill="#0C3455"/>
				</svg>
			`);
		} else {
			$btn.html(`
				<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
					<rect y="7" width="16" height="2" rx="1" fill="#0C3455"/>
					<rect x="9" width="16" height="2" rx="1" transform="rotate(90 9 0)" fill="#0C3455"/>
				</svg>
			`);
		}
	});
});